import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { useAuth } from "../Context/AuthContext";
import { Base_URL, tempURl } from "../url";

const GoogleSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { loginWithToken } = useAuth(); // We'll add this method
  const [processing, setProcessing] = useState(true);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");

    if (token) {
      localStorage.setItem("token", token);

      // Fetch user info and login
      fetch(`${tempURl}/auth/userinfo?token=${token}`)
        .then((res) => res.json())
        .then((userDetails) => {
          if (userDetails && userDetails.userId) {
            localStorage.setItem("userDetails", JSON.stringify(userDetails));
            toast.success("Google login successful!");
            navigate("/home");
          } else {
            throw new Error("Invalid user data");
          }
        })
        .catch((err) => {
          console.error("Google login error:", err);
          toast.error("Failed to fetch user details");
          navigate("/");
        })
        .finally(() => {
          setProcessing(false);
        });
    } else {
      toast.error("No token received");
      navigate("/");
      setProcessing(false);
    }
  }, [location, navigate]);

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background:
          "linear-gradient(135deg, #1e3c72 0%, #2a5298 50%, #6dd5fa 100%)",
      }}
    >
      <div
        style={{
          background: "white",
          padding: "40px",
          borderRadius: "20px",
          textAlign: "center",
          boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
        }}
      >
        {processing ? (
          <>
            <div
              className="spinner-border text-primary"
              role="status"
              style={{ width: "50px", height: "50px" }}
            >
              <span className="visually-hidden">Loading...</span>
            </div>
            <h3 className="mt-3">Completing Google Login...</h3>
            <p>Please wait while we redirect you.</p>
          </>
        ) : (
          <h3>Redirecting...</h3>
        )}
      </div>
    </div>
  );
};

export default GoogleSuccess;
